import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import i18n from 'simple-react-i18n'
import {
    H_CAMPAIGN_PLUVIO_DASHBOARD,
    H_CAMPAIGN_PLUVIO_TRACKING,
} from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import CityAction from '../../../referencial/components/city/actions/CityAction'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import PluviometryAction from '../../actions/PluviometryAction'
import { Box, Card, CardContent, Stack } from '@mui/material'
import ProgressBar from 'components/progress/ProgressBar'
import useProgressDispatch from 'utils/customHook/useProgressDispatch'
import ContactAction from 'referencial/components/contact/actions/ContactAction'
import ReferencialAction from 'referencial/action/ReferencialAction'

const PluviometryCampaignApp = ({}) => {
    const { id } = useParams()
    const dispatch = useDispatch()

    const links = id !== 'new' ? [
        {
            href: `/pluviometry/campaign/${id}/dashboard`,
            icons: 'dashboard',
            name: i18n.dashboard,
            habilitation: H_CAMPAIGN_PLUVIO_DASHBOARD,
        },
        {
            href: `/pluviometry/campaign/${id}/tracking`,
            icons: 'insert_drive_file',
            name: i18n.tracking,
            habilitation: H_CAMPAIGN_PLUVIO_TRACKING,
        },
        {
            href: `/pluviometry/campaign/${id}/picture`,
            icons: 'perm_media',
            name: i18n.picturesAndDocuments,
            habilitation: H_CAMPAIGN_PLUVIO_DASHBOARD,
        },
    ] : [{
        href: `/pluviometry/campaign/${id}/dashboard`,
        icons: 'dashboard',
        name: i18n.dashboard,
        habilitation: H_CAMPAIGN_PLUVIO_DASHBOARD,
    }].filter(l => componentHasHabilitations(l.habilitation))

    useEffect(() => {
        return () => {
            dispatch(CampaignAction.resetCampaign())
        }
    }, [])

    const { progress, isLoaded } = useProgressDispatch(() => {
        const campaignFetch = id !== 'new' ?
            [
                dispatch(CampaignAction.fetchCampaign('pluviometry', id)),
                dispatch(CampaignAction.fetchCampaignStation('pluviometry', id)),
                dispatch(CampaignAction.fetchCampaignProgress('pluviometry', id)),
                dispatch(CampaignAction.fetchStationCampaignDetails('pluviometry', id)),
            ]
            :
            []
        return [
            dispatch(PluviometryAction.fetchPluviometers()),
            dispatch(CityAction.fetchCities()),
            dispatch(ContactAction.fetchContacts()),
            dispatch(ReferencialAction.fetchSandreCodes()),
            ...campaignFetch,
        ]
    }, [id])

    return (
        <Box>
            <FixedSlideNav links={links} />
            <Box padding={1} className='content-page fullscreen'>
                <BoundaryError>
                    {isLoaded ?
                        <Outlet />
                        :
                        <Stack padding={1}>
                            <Card>
                                <CardContent>
                                    <ProgressBar progress={progress} withMessage />
                                </CardContent>
                            </Card>
                        </Stack>
                    }
                </BoundaryError>
            </Box>
        </Box>
    )
}

export default PluviometryCampaignApp
